<template>
  <div
    :class="[
      'sidebar bg-white border-end position-fixed h-100 shadow-sm',
      { 'sidebar-open': isOpen },
    ]"
  >
    <!-- Logo & Site Name -->
    <div class="text-center py-4 border-bottom flex-shrink-0">
      <img
        src="@/assets/edu-logo.png"
        alt="EduLearn Logo"
        width="80"
        height="80"
        class="rounded-circle mb-2"
      />
      <h5 class="fw-bold text-primary">{{ siteName }}</h5>
    </div>

    <!-- Sidebar Links -->
    <div class="sidebar-links flex-grow-1 overflow-auto">
      <ul class="list-unstyled p-3 mt-3">

        <li v-for="link in links" :key="link.path" class="mb-3">
          <router-link
            :to="link.path"
            class="text-decoration-none d-block py-2 px-3 rounded sidebar-link"
            active-class="active-link"
            @click="$emit('close-sidebar')"
          >
            <i :class="['bi', link.icon, 'me-2']"></i>{{ link.name }}
          </router-link>
        </li>

      </ul>
    </div>

    <!-- Footer -->
    <div class="mt-auto text-center py-3 small text-muted border-top flex-shrink-0">
      Powered by <strong>MySoftCode</strong>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    isOpen: { type: Boolean, default: false },
  },
  emits: ["close-sidebar"],
  data() {
    return {
      siteName: "EduLearn Academy",
      links: [
        { name: "Home", path: "/", icon: "bi-house" },
        { name: "Tutorials", path: "/tutorials", icon: "bi-laptop" },
        { name: "Courses", path: "/courses", icon: "bi-journal-bookmark" },
        { name: "About", path: "/about", icon: "bi-info-circle" },
        { name: "Blog", path: "/blog", icon: "bi-chat-left-text" },
        { name: "Contact", path: "/contact", icon: "bi-telephone" },
      ],
    };
  },
};
</script>


<style scoped>
.sidebar {
  width: 250px;
  left: -250px;
  top: 0;
  transition: left 0.3s ease;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  height: 100vh; /* full height */
}

.sidebar-open {
  left: 0;
}

.sidebar-links {
  flex-grow: 1;
  overflow-y: auto; /* vertical scroll */
}

.sidebar-link {
  color: #0d6efd;
  font-weight: 500;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;
}

.sidebar-link:hover {
  background-color: #e2f0ff;
  color: #0a58ca;
}

.sidebar-sub-link {
  color: #0d6efd;
  font-weight: 400;
  font-size: 0.95rem;
  transition: background-color 0.2s, color 0.2s;
}

.sidebar-sub-link:hover {
  background-color: #e9f5ff;
  color: #0a58ca;
}

.active-link {
  background-color: #ffc107;
  color: #212529 !important;
}

h5 {
  font-size: 1.25rem;
  margin: 0;
}

@media (max-width: 991px) {
  .sidebar {
    top: 0;
  }
}
</style>
